import { render } from "./vue-file-agent.vue?vue&type=template&id=cbe1c2e2&ts=true"
import script from "./vue-file-agent.vue?vue&type=script&lang=ts"
export * from "./vue-file-agent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../ss/NE/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__